import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from '@marketplace-web/browser/browser-storage-util'

import { SHOULD_SHOW_VAN_OFFER_SESSION_KEY } from '../../constants'

function useShouldShowVanOffer() {
  const { screen: screenName } = useSession()
  const isVanOfferAdEnabled = useFeatureSwitch('web_van_offer_ad')
  const shouldUserSeeAds = useAbTest('sqp_ads')?.variant === 'on'

  const isInInbox = ['message_list', 'message_new', 'message_reply'].includes(screenName)

  const isVanOfferAvailable = isVanOfferAdEnabled && isInInbox && shouldUserSeeAds

  const shouldShowVanOffer =
    isVanOfferAvailable && getSessionStorageItem(SHOULD_SHOW_VAN_OFFER_SESSION_KEY) === 'true'

  function setShouldShowVan(shouldShowVanValue: boolean) {
    if (shouldShowVanValue) {
      setSessionStorageItem(SHOULD_SHOW_VAN_OFFER_SESSION_KEY, String(shouldShowVanValue))

      return
    }

    removeSessionStorageItem(SHOULD_SHOW_VAN_OFFER_SESSION_KEY)
  }

  return {
    setShouldShowVan,
    shouldShowVanOffer,
  }
}

export default useShouldShowVanOffer
